import { render } from "./SelectTrademarksSelected.vue?vue&type=template&id=8b6b2866&scoped=true&ts=true"
import script from "./SelectTrademarksSelected.vue?vue&type=script&lang=ts"
export * from "./SelectTrademarksSelected.vue?vue&type=script&lang=ts"

import "./SelectTrademarksSelected.vue?vue&type=style&index=0&id=8b6b2866&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6b2866"]])

export default __exports__